// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__jRgkk","container":"Loader_container__QClwY","circle":"Loader_circle__lZ6rO","scaling":"Loader_scaling__6DfgE"};